// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_NEW,
} from "constants/FormatDataContanst";
import { getResourceIdXML } from "helpers/form_helper";
import { generateSelectField } from "helpers/form_helper_old";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import PDFViewModal from "pages/IssueInvoice/modal/PDFViewModal";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row, Spinner } from "reactstrap";
import {
  downloadXmlIssueInvoice,
  loadConfigInvoiceField,
  resetDownloadXmlIssueInvoice,
} from "store/actions";
import {
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import {
  createInvoiceCycles,
  listInvoiceToSummary,
  listKhddInvoiceToSummary,
  resetCreateInvoiceCycles,
  resetListInvoiceToSummary,
} from "store/summary-invoice-data/actions";
import {
  CREATE_INVOICE_CYCLES_FAIL,
  CREATE_INVOICE_CYCLES_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";
const CreateData = props => {
  const [optionYear, setOptionYear] = useState(null);
  const [paramsFilter, setParamsFilter] = useState(null);
  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    listKHHD,
    listInvoiceToSummaryData,
    type: typeSummaryInvoiceData,
  } = summaryInvoiceData;

  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    fileDownload,
    fileDownloadName,
    type: typeissueInvoice,
    configField,
    currentTime,
  } = issueInvoice;

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  const [rowSelected, setRowSelected] = useState([]);

  const [dataTable, setDataTable] = useState([]);

  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };
  const history = useHistory();

  // Convert Data Use For DataTable
  useEffect(() => {
    if (listInvoiceToSummaryData.data) {
      setDataTable([...listInvoiceToSummaryData.data]);
    }
  }, [listInvoiceToSummaryData]);

  useEffect(() => {
    switch (typeissueInvoice) {
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });

        dispatch(resetDownloadXmlIssueInvoice());
        break;
      }
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadXmlIssueInvoice());
        break;
    }
  }, [typeissueInvoice]);

  useEffect(() => {
    switch (typeSummaryInvoiceData) {
      case CREATE_INVOICE_CYCLES_SUCCESS: {
        addToast("Tạo bảng tổng hợp thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        history.push("/report/list-invoice-cycles");
        dispatch(resetCreateInvoiceCycles());
        break;
      }
      case CREATE_INVOICE_CYCLES_FAIL:
        addToast("Tạo bảng tổng hợp thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateInvoiceCycles());
        break;
    }
  }, [typeSummaryInvoiceData]);

  useEffect(() => {
    dispatch(listKhddInvoiceToSummary(getValues("khmshdon").value));
    dispatch(loadConfigInvoiceField());
    return () => {
      dispatch(resetListInvoiceToSummary());
    };
  }, []);

  useEffect(() => {
    if (currentTime) {
      let currentYear = currentTime?.data?.year;
      const listYear = [];
      for (let i = 0; i < 3; i++) {
        listYear.push({
          value: currentYear,
          label: "Năm " + currentYear,
        });
        currentYear = currentYear - 1;
      }
      setOptionYear(listYear);
      setValue("year", listYear[0]);
    }
  }, [currentTime]);

  const objectAll = {
    value: "All",
    label: "Tất cả",
  };

  useEffect(() => {
    if (listKHHD.data) {
      setValue("khhdon", objectAll);
    }
  }, [listKHHD]);

  const OPTION_TYPE_TIME = [
    {
      value: "quarter",
      label: "Quý",
    },
    {
      value: "month",
      label: "Tháng",
    },
  ];
  const { addToast } = useToasts();

  const OPTION_quarter = [
    {
      value: "01",
      label: "Quý 1",
    },
    {
      value: "02",
      label: "Quý 2",
    },
    {
      value: "03",
      label: "Quý 3",
    },
    {
      value: "04",
      label: "Quý 4",
    },
  ];

  const OPTION_MONTH = [
    {
      value: "01",
      label: "Tháng 1",
    },
    {
      value: "02",
      label: "Tháng 2",
    },
    {
      value: "03",
      label: "Tháng 3",
    },
    {
      value: "04",
      label: "Tháng 4",
    },
    {
      value: "05",
      label: "Tháng 5",
    },
    {
      value: "06",
      label: "Tháng 6",
    },
    {
      value: "07",
      label: "Tháng 7",
    },
    {
      value: "08",
      label: "Tháng 8",
    },
    {
      value: "09",
      label: "Tháng 9",
    },
    {
      value: "10",
      label: "Tháng 10",
    },
    {
      value: "11",
      label: "Tháng 11",
    },
    {
      value: "12",
      label: "Tháng 12",
    },
  ];

  const OPTION_KHMSHDON = [
    // {
    //   value: "all",
    //   label: "Tất cả",
    // },
    {
      value: "1",
      label: "1 - HÓA ĐƠN GIÁ TRỊ GIA TĂNG ĐIỆN TỬ (TT78)",
    },
    {
      value: "2",
      label: "2 - HÓA ĐƠN BÁN HÀNG ĐIỆN TỬ (TT78)",
    },
    {
      value: "5",
      label: "5 - TEM VÉ ĐIỆN TỬ (TT78)",
    },
  ];

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);
  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  const schema = yup.object().shape({
    // THông tin chung
    typeTime: yup.object(),
    quarter: yup.object(),
    month: yup.object(),
    year: yup.object(),
    khmshdon: yup.object(),
    khhdon: yup.object().required("Vui lòng chọn"),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      typeTime: OPTION_TYPE_TIME[0],
      quarter: OPTION_quarter[0],
      month: OPTION_MONTH[0],
      khmshdon: OPTION_KHMSHDON[0],
      //   khhdon: OPTION_KHHDON[0],
    },
  });

  const onSubmit = values => {
    const { khhdon, khmshdon, month, quarter, typeTime, year } = values;

    let params = null;
    if (typeTime.value === "quarter") {
      params = {
        quarter: quarter.value,
        year: year.value,
        kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
        type: 2,
      };
    }
    if (typeTime.value === "month") {
      params = {
        month: month.value,
        year: year.value,
        kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
        type: 2,
      };
    }
    setParamsFilter(params);
    dispatch(listInvoiceToSummary(params, khmshdon.value));
    setRowSelected([]);
  };

  const pageOptionsSuccess = {
    sizePerPage: 10,
    onPageChange: page => {
      setRowSelected([]);
      //   setCurrentPageSuccess(page);
    },
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "35",
        value: 35,
      },
      {
        text: "400", // max from api
        value: 400,
      },
    ],
    // page: 10,
    // sizePerPageList: [
    //   ...commonSizePerPageList,
    //   {
    //     text: t("pageAll"),
    //     value: listItemSuccess.length,
    //   },
    // ],
    hidePageListOnlyOnePage: true, // hide pagination bar when only 1 page
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let text = "";
    switch (status) {
      // Hủy
      case AUTH_STATUS_CANCEL:
        text = "Hủy";
        break;
      // Phát hành
      case AUTH_STATUS_APPROVE:
        text = "Đã phát hành";
        // Phát hành
        switch (row.tthdlquan_tchdon) {
          // Thay thế
          case "1":
            text = "Thay thế";
            break;
          // Điều chỉnh
          case "2":
            text = "Điều chỉnh";
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const numberWithCommas = (x, isShow) => {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const initColumns = [
    // {
    //   dataField: "pban",
    //   text: t("table.version"),
    //   // sort: true,
    //   // filter: textFilter({
    //   //   placeholder: t("placeholder.enter", {
    //   //     title: t("table.message_sender"),
    //   //   }),
    //   // }),
    // },
    {
      dataField: "id",
      text: "id",
      sort: true,
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
    },
    {
      dataField: "ttchung_thdon",
      text: t("table.invoice_name"),
      sort: true,
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
    },
    {
      dataField: "auth_status",
      text: t("auth_status.name"),
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row),
    },
    {
      dataField: "ttchung_khmshdon",
      text: t("table.invoice_model_number_symbol"),
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      hidden: true,
    },
    {
      dataField: "ttchung_khhdon",
      text: t("table.invoice_symbol"),
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
    },
    {
      dataField: "ttchung_shdon",
      text: t("table.invoice_number"),
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      //   }),
      formatter: (cellContent, row) => {
        return cellContent !== "0" && cellContent ? cellContent : "Chờ cấp số";
      },
    },
    {
      dataField: "newStatus",
      text: "Thay đổi trạng thái",
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "Giữ nguyên",
            label: "Giữ nguyên",
          },
          {
            value: "Giải trình",
            label: "Giải trình",
          },
        ],
      },
      hidden: false,
      // formatter: (cellContent, row) => getAuthStatus(row),
    },
    {
      dataField: "sTbao",
      text: "Số thông báo",
      sort: true,
    },
    {
      dataField: "dateTbao",
      text: "Ngày thông báo",
      editor: {
        type: Type.DATE,
      },
    },
    {
      dataField: "noteTbao",
      text: "Ghi chú",
      sort: true,
    },

    {
      dataField: "lhdclquan",
      text: "Loại hóa đơn có liên quan",
      sort: true,
      formatter: (cellContent, row) => {
        let text = "";
        //TODO: hiện tại chỉ có loại này
        if (row.tthdlquan_khmshdclquan) {
          text =
            "1 - Hóa đơn điện tử theo Nghị định 123/2020/NĐ-CP ( Thông tư 78 )";
        }
        return text;
      },
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
    },
    {
      dataField: "tthdlquan_khhdclquan",
      text: "Ký hiệu HĐ có liên quan",
      sort: true,
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
    },
    {
      dataField: "tthdlquan_khmshdclquan",
      text: "Ký hiệu mẫu số HĐ có liên quan",
      sort: true,
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
    },
    {
      dataField: "tthdlquan_shdclquan",
      text: "Số HĐ có liên quan",
      sort: true,
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
    },
    {
      dataField: "ttchung_nlap",
      text: t("table.date_created"),
      formatter: (cellContent, row) => tableFormateDate(row.ttchung_nlap),
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      //   filter: customFilter({
      //     type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      //   }),
      //   filterRenderer: (onFilter, column) => (
      //     <CustomDateFilter
      //       onFilter={onFilter}
      //       column={column}
      //       paramFilter={issueInvoiceList.params.columnFilter}
      //     />
      //   ),
    },
    // {
    //   dataField: "nmua_mst",
    //   text: "MST người mua hàng",
    //   editable: (cell, row, rowIndex, colIndex) => {
    //     return false;
    //   },
    //   sort: true,
    //   //   filter: textFilter({
    //   //     placeholder: t("placeholder.enter"),
    //   //   }),
    // },
    {
      dataField: "nmua_ten",
      text: t("form.nmua_ten"),
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      sort: true,
    },
    {
      dataField: "ttoan_tgtcthue",
      text: "Tổng tiền chưa thuế",
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      type: "number",
      sort: true,
      formatter: (cellContent, row) => {
        return numberWithCommas(cellContent);
      },
    },
    {
      dataField: "ttoan_tgtthue",
      text: "Tổng tiền thuế",
      type: "number",
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      sort: true,
      formatter: (cellContent, row) => {
        return numberWithCommas(cellContent);
      },
    },
    {
      dataField: "ttoan_tgtttbso",
      text: "Tổng tiền thanh toán bằng số",
      type: "number",
      sort: true,
      editable: (cell, row, rowIndex, colIndex) => {
        return false;
      },
      formatter: (cellContent, row) => {
        return numberWithCommas(cellContent);
      },
    },
    {
      dataField: "action",
      text: "",
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-2 font-size-18 ">
            <i
              title="Download Xml"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (row.resource_list && row.resource_list.length > 0) {
                  let resource_id = null;
                  let type = "";
                  if (row.auth_status === AUTH_STATUS_NEW) {
                    type = "raw";
                  } else if (row.auth_status === AUTH_STATUS_APPROVE) {
                    type = "tct-response";
                  } else {
                    type = "signed";
                  }
                  resource_id = getResourceIdXML(row.resource_list, type);
                  if (resource_id) {
                    dispatch(
                      downloadXmlIssueInvoice(resource_id, row.ttchung_thdon)
                    );
                  } else {
                    addToast("Tải xuống thất bại", {
                      appearance: "error",
                      autoDismiss: true,
                    });
                  }
                } else {
                  if (row.resource_id) {
                    dispatch(
                      downloadXmlIssueInvoice(
                        row.resource_id,
                        row.ttchung_thdon
                      )
                    );
                  } else {
                    addToast("Tải xuống thất bại", {
                      appearance: "error",
                      autoDismiss: true,
                    });
                  }
                }
              }}
              className="bx bx-download label-icon text-primary"
            />
            <i
              title="Bản hiển thị"
              style={{ cursor: "pointer" }}
              onClick={() => {
                showPdfById(row.id);
              }}
              className="bx bxs-file-pdf label-icon text-danger"
            />
          </div>
        );
      },
    },
  ];

  const handleOnSelect = (row, isSelect) => {
    let data = [];

    if (isSelect) {
      data = [...rowSelected, row.id];
    } else {
      data = rowSelected.filter(x => x !== row.id);
    }
    setRowSelected(data);
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map(r => r.id);
    let data = [];
    if (isSelect) {
      data = ids;
    }
    setRowSelected(data);
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    clickToEdit: true,
    selected: rowSelected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };

  const createCycles = () => {
    const listSelect = [];
    for (const item of dataTable) {
      if (rowSelected.indexOf(item.id) !== -1) {
        let tthai = null;
        if (item.newStatus === "Giải trình") {
          tthai = 4;
        } else {
          // giừ nguyên
          switch (item.auth_status) {
            // Hủy
            case AUTH_STATUS_CANCEL:
              tthai = 1;
              break;
            // Phát hành
            case AUTH_STATUS_APPROVE:
              tthai = 0;
              // Phát hành
              switch (item.tthdlquan_tchdon) {
                // Thay thế
                case "1":
                  tthai = 3;
                  break;
                // Điều chỉnh
                case "2":
                  tthai = 2;
                  break;
                default:
                  break;
              }
              break;
            default:
              break;
          }
        }
        listSelect.push({
          id: item.id,
          tthai: tthai,
          lhdclquan: item.tthdlquan_khmshdclquan ? 1 : "", // mặc định là Hóa đơn điện tử theo Nghị định 123/2020/NĐ-CP ( Thông tư 78 )
          khmshdclquan: item.tthdlquan_khmshdclquan,
          khhdclquan: item.tthdlquan_khhdclquan,
          shdclquan: item.tthdlquan_shdclquan,
          stbao: item.sTbao,
          ntbao: item.dateTbao,
          gchu: item.noteTbao,
        });
      }
    }

    let lkdlieu = "";
    let kdlieu = "";
    if (paramsFilter.month) {
      lkdlieu = "T";
      kdlieu = `${paramsFilter.month}/${paramsFilter.year}`;
    }
    if (paramsFilter.quarter) {
      lkdlieu = "Q";
      kdlieu = `${paramsFilter.quarter}/${paramsFilter.year}`;
    }
    const dataSubmit = {
      mso: "01/TH-HĐĐT",
      ten: "BẢNG TỔNG HỢP DỮ LIỆU HÓA ĐƠN ĐIỆN TỬ ĐẾN CƠ QUAN THUẾ",
      //   sbthdlieu: 3,
      lkdlieu: lkdlieu,
      kdlieu: kdlieu,
      //   ldau: 1,
      //   bslthu: 1,
      nlap: new Date().getTime(),
      tnnt: finalBuInfo.ten,
      mst: finalBuInfo.mst,
      hddin: 0,
      lhhoa: 9,
      invoice_id: listSelect,
      //   ndbthdlieu: rowSelected,
    };
    console.log(
      "🚀 ~ file: CreateData.js ~ line 797 ~ createCycles ~ dataSubmit",
      dataSubmit
    );
    dispatch(createInvoiceCycles(dataSubmit));
    setRowSelected([]);
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: dataTable.length, // replace later with size(customers),
    custom: true,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Lập bảng tổng hợp dữ liệu hóa đơn</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Lập bảng tổng hợp dữ liệu hóa đơn"}
          />
          {/* PDFViewModal */}
          <PDFViewModal
            isOpen={modalPdfView}
            dataViewDocument={dataViewDocument}
            toggle={togglePdfViewModal}
          ></PDFViewModal>
          {/* <div className="d-flex justify-content-right">
            <Button
              type="button"
              color="primary"
              className="me-2 btn-label"
              onClick={() => {}}
            >
              <i className="bx bxs-printer label-icon" />
              Xuất excel
            </Button>
            <Button
              type="button"
              color="primary"
              className="me-2 btn-label"
              onClick={() => {}}
            >
              <i className="bx bxs-printer label-icon" />
              Xuất PDF
            </Button>
          </div> */}
          <Card>
            <CardBody style={{ minHeight: "450px" }}>
              <Row className="row-cols-1 row-cols-md-3">
                {/* Loại */}
                <Col style={{}}>
                  {generateSelectField(
                    "Loại",
                    true,
                    errors,
                    "typeTime",
                    "Vui lòng chọn",
                    false,
                    control,
                    OPTION_TYPE_TIME,
                    "auto",
                    () => {
                      //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                      //   if (cqtqly?.code) {
                      //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                      //       shouldValidate: true,
                      //     });
                      //   }
                    },
                    true
                  )}
                </Col>
                {watch("typeTime").value === OPTION_TYPE_TIME[0].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Quý",
                      true,
                      errors,
                      "quarter",
                      "Vui lòng chọn",
                      false,
                      control,
                      OPTION_quarter,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      true
                    )}
                  </Col>
                )}
                {watch("typeTime").value === OPTION_TYPE_TIME[1].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Tháng",
                      true,
                      errors,
                      "month",
                      "Vui lòng chọn",
                      false,
                      control,
                      OPTION_MONTH,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      true
                    )}
                  </Col>
                )}

                <Col style={{}}>
                  {generateSelectField(
                    "Năm",
                    true,
                    errors,
                    "year",
                    "Vui lòng chọn",
                    false,
                    control,
                    optionYear,
                    "auto",
                    () => {
                      //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                      //   if (cqtqly?.code) {
                      //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                      //       shouldValidate: true,
                      //     });
                      //   }
                    },
                    true
                  )}
                </Col>
              </Row>
              <Row className="row-cols-1 row-cols-md-3 mt-2">
                <Col style={{}}>
                  {generateSelectField(
                    "Mẫu hóa đơn",
                    true,
                    errors,
                    "khmshdon",
                    "Vui lòng chọn",
                    false,
                    control,
                    OPTION_KHMSHDON,
                    "auto",
                    () => {
                      dispatch(
                        listKhddInvoiceToSummary(getValues("khmshdon").value)
                      );
                    },
                    true
                  )}
                </Col>
                <Col style={{}}>
                  {listKHHD.loading ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "self-end",
                        height: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    generateSelectField(
                      "Ký hiệu hóa đơn",
                      true,
                      errors,
                      "khhdon",
                      "Vui lòng chọn",
                      false,
                      control,
                      [
                        objectAll,
                        ...listKHHD.data.map(item => {
                          return {
                            value: item,
                            label: item,
                          };
                        }),
                      ],
                      "auto",
                      () => {
                        // dispatch(listKhddInvoiceToSummary());
                      },
                      false
                    )
                  )}
                </Col>
              </Row>
              <div className="mt-4 d-flex justify-content-center">
                <Button
                  type="button"
                  color="warning"
                  className="me-2 btn-label"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  <i className="bx bx-receipt label-icon" />
                  Preview
                </Button>
                {/* <Button
                  type="button"
                  color="success"
                  className="me-2 btn-label"
                  onClick={() => {}}
                >
                  <i className="bx bxs-printer label-icon" />
                  Gửi duyệt
                </Button> */}
                <Button
                  type="button"
                  color="primary"
                  className="me-2 btn-label"
                  disabled={rowSelected.length === 0}
                  onClick={() => {
                    createCycles();
                  }}
                >
                  <i className="bx bx-save label-icon" />
                  Tạo bảng tổng hợp
                </Button>
              </div>

              <Row>
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      {listInvoiceToSummaryData.loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "self-end",
                            height: "100%",
                            justifyContent: "center",
                          }}
                        >
                          <Spinner color="primary" />
                        </div>
                      ) : dataTable && dataTable.length > 0 ? (
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="id"
                          columns={initColumns}
                          data={dataTable}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="id"
                              columns={initColumns}
                              data={dataTable}
                              search
                            >
                              {toolkitProps => (
                                <React.Fragment>
                                  <Row>
                                    <div className="d-flex gap-3 font-size-16 mb-2">
                                      <div className="text-info">
                                        <strong>
                                          Hóa đơn hợp lệ ({dataTable.length})
                                        </strong>
                                      </div>
                                      <div className="text-success">
                                        <strong>
                                          Hóa đơn đã chọn (
                                          {rowSelected.length > 0
                                            ? rowSelected.length
                                            : 0}
                                          )
                                        </strong>
                                      </div>
                                    </div>
                                  </Row>
                                  <Row>
                                    <Col xl="12">
                                      <div className="table-responsive">
                                        <BootstrapTable
                                          keyField={"id"}
                                          responsive
                                          bordered={false}
                                          striped={false}
                                          defaultSorted={defaultSorted}
                                          selectRow={selectRow}
                                          cellEdit={cellEditFactory({
                                            mode: "dbclick",
                                          })}
                                          classes={
                                            "table align-middle table-nowrap"
                                          }
                                          headerWrapperClasses={"thead-light"}
                                          {...toolkitProps.baseProps}
                                          {...paginationTableProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row className="align-items-md-center mt-30">
                                    <Col className="inner-custom-pagination d-flex">
                                      <div className="d-inline">
                                        <SizePerPageDropdownStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                      <div className="text-md-right ms-auto">
                                        <PaginationListStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      ) : (
                        <div className="text-center" style={{}}>
                          Không có hóa đơn
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateData;
